import { gql } from "@apollo/client";

export const GET_BRAND_SEO = gql`
  query getSEOBySlug($slug: String!) {
    getBySlugMerchantBrand(slug: $slug) {
      orderId
      brand
      title
      metaDescription
      h1
      h2CashBack
      h2Discount
      merchantContent
      slug
    }

    canLoadAdForBrand(path: $slug)
  }
`;
